/* eslint-disable react/no-unescaped-entities */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Popup from "@src/components/UIElements/Popup";
import Button from "@src/components/UIElements/Button/index";
import { Image } from "@src/components/Image";
import { getAwsAssets } from "@src/utils";
import { buyNowSuccessModal } from "@src/components/Tabs/Overview/store/actions";
import { t } from "i18next";
import {
  showSelectAddressBottomSheetAction,
  showSelectStateBottomSheetAction,
} from "../../store/actions";

function BuyNowSuccess() {
  const showBuyNowSuccess = useSelector(
    (state) => state?.overviewReducer?.showBuyNowSuccess
  );
  const purchaseViaWhatsappV2 = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.purchaseViaWhatsappV2
  );
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(showSelectStateBottomSheetAction(false));
    dispatch(showSelectAddressBottomSheetAction(false));
    if (showBuyNowSuccess) {
      setTimeout(() => {
        dispatch(buyNowSuccessModal(false));
      }, [10000]);
    }
  }, [showBuyNowSuccess]);

  const handleClose = () => {
    dispatch(buyNowSuccessModal(false));
  };

  return (
    <Popup showPopup={showBuyNowSuccess} handleClose={handleClose}>
      <div className="couponsAppliedPopup">
        <Image
          src={getAwsAssets("CouponSuccess.gif", "Overview")}
          className="GIFCoupons"
          width="80"
          height="80"
        />
        <div className="couponSuccessApplied">
          {t(
            "components.BottomSheets.components.BuyNowSuccess.index.success",
            "Success"
          )}
        </div>
        <div className="couponSuccessAppliedText">
          {purchaseViaWhatsappV2 === 1
            ? t(
                "components.BottomSheets.components.BuyNowSuccess.index.successContent",
                "Thank you for your interest. Please check your WhatsApp/SMS for the Next Steps."
              )
            : t(
                "components.BottomSheets.components.BuyNowSuccess.index.successContent",
                "Thank you for your interest. Please check your WhatsApp/SMS for the Next Steps."
              )}
        </div>
        <Button
          className="viewALLBtnMobile"
          onClick={handleClose}
          style={{ marginTop: "25px", fontWeight: "600" }}
        >
          {t(
            "components.BottomSheets.components.BuyNowSuccess.index.successOntentDone",
            "Done"
          )}
        </Button>
      </div>
    </Popup>
  );
}

export default BuyNowSuccess;
